<template>
	<b-modal ref="mdlAgendaNuovoAppuntamentoModalComponent" no-close-on-backdrop no-close-on-select
		title="Dettaglio Appuntamento" hide-footer>
		<div class="modal-body">
			<b-row>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label for="cognome">Cognome</label>
					<input type="text" name="cognome" class="form-control" v-model="objectAppuntamento.cognome" />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label for="nome">Nome</label>
					<input type="text" name="nome" class="form-control" v-model="objectAppuntamento.nome" />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
					<label for="identificativoAppuntamento">Tipo Id.</label>
					<b-form-select v-model="objectAppuntamento.tipoIdentificativo" class="mb-2 mr-sm-2 mb-sm-0"
						:options="tipoIdentificativoOptions" :value="null"></b-form-select>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
					<label for="identificativoAppuntamento">{{ this.$i18n.t("patients.lblFiscalCode") }}</label>
					<input type="text" name="identificativoAppuntamento" class="form-control text-upper"
						v-model="objectAppuntamento.identificativoAppuntamento" />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="codicePrestazione">{{ this.$i18n.t("patient.agenda.lblPerformanceCode") }}</label>
					<input name="codicePrestazione" class="form-control" v-model="objectAppuntamento.codicePrestazione"
						disabled />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="descrizionePrestazione">{{ this.$i18n.t("patient.agenda.lblDescriptionPerformance")
					}}</label>
					<input type="text" name="descrizionePrestazione" class="form-control"
						v-model="objectAppuntamento.descrizionePrestazione" />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="costo">{{ this.$i18n.t("patient.agenda.lblCost") }} (in €)</label>
					<input type="text" name="costo" class="form-control" v-model="objectAppuntamento.costo" />
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="dataOraInizio">{{ this.$i18n.t("patient.agenda.lblDateReference") }}</label>
					<date-picker format="DD-MM-YYYY" value-type="timestamp" v-model="objectAppuntamento.dataRiferimento"
						type="timestamp" disabled></date-picker>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label for="dataInizio">{{ this.$i18n.t("patient.agenda.lblStartTime") }}</label>
					<date-picker format="HH:mm" value-type="timestamp" v-model="objectAppuntamento.dataOraInizio"
						type="time" placeholder="HH:mm" disabled></date-picker>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
					<label for="indirizzo">{{ this.$i18n.t("patient.agenda.lblEndTime") }}</label>
					<date-picker format="HH:mm" value-type="timestamp" v-model="objectAppuntamento.dataOraFine"
						type="time" placeholder="HH:mm" disabled></date-picker>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label>Tipologia Visita</label>
					<b-form-select v-model="objectAppuntamento.tipologiaVisita" :placeholder="'Tipologia Agenda'">
						<template>
							<b-form-select-option v-for="pres of tipologiaVisitaOptions" :value="pres.nome"
								:key="pres.nome"> {{
									pres.nome }} </b-form-select-option>
						</template>
					</b-form-select>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
					<label>Stato Attuale</label>
					<b-form-select v-model="objectAppuntamento.statoAttuale" :placeholder="'Tipologia Agenda'">
						<template>
							<b-form-select-option v-for="pres of statoOptions" :value="pres.nome" :key="pres.nome"> {{
								pres.nome }} </b-form-select-option>
						</template>
					</b-form-select>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
					<label>Stato Attuale Data Ora</label>
					<date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp"
						v-model="objectAppuntamento.statoAttualeDataOra" type="time" placeholder="DD-MM-YYYY HH:mm"
						disabled></date-picker>
				</b-col>
				<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
					<label for="note">{{ this.$i18n.t("patient.diet.lblNote") }}</label>
					<b-form-textarea class="form-control" name="note" v-model="objectAppuntamento.note" rows="3"
						no-resize></b-form-textarea>
				</b-col>
			</b-row>
		</div>
		<hr />
		<b-row>
			<div class="sa-padding-right text-right col">
				<b-button type="button" variant="secondary" @click="onCancel">{{ this.$i18n.t("global.lblBtnCancel")
				}}</b-button>
				<b-button type="button" variant="primary" @click="onSave">{{ this.$i18n.t("global.lblBtnSave")
				}}</b-button>
			</div>
		</b-row>
		<sa-modal-loading ref="mdlSaModalLoading"></sa-modal-loading>
	</b-modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
import { SaModalLoading } from "../../utility";
import moment from "moment";
import axios from "axios";
import toast from "../../../template/layout/utility/sa-toast";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker, SaModalLoading },
	mounted: function () {
		this.loadDataTipologieVisita();
		this.loadStatiAppuntamento();
	},
	data() {
		return {
			tipologiaVisitaOptions: [],
			statoOptions: [],
			pathResourceAgendaAppuntamenti: "/agendaappuntamenti",
			objectAppuntamento: { idAgenda: null, cognome: null, tipologiaVisita: null, tipoIdentificativo: "CF", identificativoAppuntamento: null, codicePrestazione: null, descrizionePrestazione: null, dataOraInizio: null, dataOraFine: null, dataRiferimento: null, costo: null, note: null },
			tipoIdentificativoOptions: [
				{ value: "CF", text: "Cod. Fiscale" },
				{ value: "TEL", text: "Numero di Telefono" },
			],
		};
	},
	watch: {
		'objectAppuntamento.dataRiferimento': function (params) {
			console.log(params);
			if (typeof params == "string") {
				const [year, month, day] = params.split('-');
				this.objectAppuntamento.dataRiferimento = new Date(year, month - 1, day).getTime();

			}

		}
	}
	,
	methods: {
		show(objectAppuntamento) {
			this.objectAppuntamento = objectAppuntamento;
			this.$refs.mdlAgendaNuovoAppuntamentoModalComponent.show();
		},
		loadDataTipologieVisita() {


			let me = this;
			let link = process.env.VUE_APP_PATH_API + "/agendatipovisite";
			me.showModalLoading = true;
			axios
				.get(link)
				.then((response) => {
					this.tipologiaVisitaOptions = response.data.data.list;

				})
				.catch(() => { });

		},
		loadStatiAppuntamento() {

			let me = this;
			let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentistati";
			me.showModalLoading = true;
			axios
				.get(link)
				.then((response) => {
					this.statoOptions = response.data.data.list;

				})
				.catch(() => { });

		},
		onCancel() {
			this.$refs.mdlAgendaNuovoAppuntamentoModalComponent.hide();
		},
		onSave() {
			let me = this;
			me.$refs.mdlSaModalLoading.show();
			me.objectAppuntamento.dataRiferimento = moment(me.objectAppuntamento.dataRiferimento).format("YYYY-MM-DD");
			UtilityMixin.methods.saveResource(me.pathResourceAgendaAppuntamenti, me.objectAppuntamento, me.saveSucessResponse, me.saveErrorResponse);
		},
		saveSucessResponse(response) {
			this.$emit("successRestCall", response);
			this.$refs.mdlAgendaNuovoAppuntamentoModalComponent.hide();
			this.$refs.mdlSaModalLoading.close();
		},
		saveErrorResponse(error) {
			console.log(error);
			let me = this;
			if (error.response.status === 400) {
				let validation = { esito: false, msg: error.response.data.messaggio }
				toast.validation(validation)
				this.$emit("errorRestCall", error);
				me.$refs.mdlSaModalLoading.close();
			} else {
				this.$bvToast.toast("Errore nel salvare i dati del Piano: " + error.message, {
					title: "",
					variant: "danger",
					solid: true,
				});
				me.$refs.mdlSaModalLoading.close();
			}
		},
	},
};
</script>

<style></style>
